export default {
    // BASE_API: '/'
    // 测试
    BASE_API: 'https://api.cbsrsgw013.cc/tea/'
    // BASE_API: 'https://api.cbsrsgw66.cc/tea/'
    // 本地
}